import Logo from "../../../assets/image/logo_1x.webp";
import Logo2x from "../../../assets/image/logo_2x.webp";
import Logo3x from "../../../assets/image/logo_3x.webp";

import { useStyles } from "./MainHeader.style";
import { Icon, Image, useCustomNavigate } from "@onmo/ui";
import Avatar from "../../core/Avatar/Avatar";
import { HTMLAttributes } from "react";
import { RankGemTag } from "../RankGemTag/RankGemTag";
import { PageRoutes } from "../../../constants/routes";
import { useQuery } from "@apollo/client/react/hooks/useQuery";
import { meGQL } from "@onmo/graphql/graphql";
import { getImage3x } from "../../../models/theme";

type IHeaderProps = HTMLAttributes<HTMLDivElement> & {
  onClickBack?: () => void;
};

const MainHeader: React.FC<IHeaderProps> = (props) => {
  const classes = useStyles();
  const { navigate } = useCustomNavigate();
  const { onClickBack } = props;
  const { data: dataMe } = useQuery(meGQL, { fetchPolicy: "cache-first" });
  const avatar = dataMe?.me?.avatar;
  const logoHeader = getImage3x("header-logo.webp");

  return (
    <div className={classes.root}>
      <div className={classes.left}>
        <Icon name="icon-bold-arrow-left-3" onClick={onClickBack} />
        <Image
          src={logoHeader?.oneX || Logo}
          src2x={logoHeader?.twoX || Logo2x}
          src3x={logoHeader?.threeX || Logo3x}
          alt="logo"
        />
      </div>
      <div className={classes.right}>
        <RankGemTag />
        <Avatar url={avatar} onClick={() => navigate(PageRoutes.Me)} />
      </div>
    </div>
  );
};

export default MainHeader;
